import { render, staticRenderFns } from "./ProfileCards.vue?vue&type=template&id=c8c74138&scoped=true&"
import script from "./ProfileCards.vue?vue&type=script&lang=js&"
export * from "./ProfileCards.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCards.vue?vue&type=style&index=0&id=c8c74138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c74138",
  null
  
)

export default component.exports